import script from "./MessageSources.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageSources.vue?vue&type=script&setup=true&lang=ts"

import "./MessageSources.vue?vue&type=style&index=0&id=ee9dfbdc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9dfbdc"]])

export default __exports__